import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {Input} from 'components/danangtrade-forms/common';
import {SingleImageUploader} from 'components/uploader';
import CONFIG from 'base/constants/config';
import style from './_HomeBannerForm.scss';
import {ShowIf} from 'components/utils';
import {toastr} from 'react-redux-toastr';
import {HomeBanners} from 'base/api';

class HomeBannerForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.props.validators['formAddHomeBanner'] = [];
  }

  state = {
    link: '',
    priority: '',
    image: null,
    dataImage: null
  }

  static defaultProps = {
    validators: {}
  }

  bindData(data) {
    const {link, priority, image} = data;

    this.setState({link, priority, image});
  }

  componentDidMount() {
    if (this.props.data) {
      this.bindData(this.props.data)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.state.data) {
      this.bindData(nextProps.data);
    }
  }

  submitForm(e) {
    e.preventDefault();

    let params = {};

    if (this.validateSubmitForm()) {
      let { ...data } = this.state;
      delete data.dataImage;
      if (this.props.data && typeof this.props.data.id != "undefined") {
        params = {id: this.props.data.id};
      }

      return this.props.dispatch(this.props.fnSubmit(params, {
        data
      })).then(response => {
        if (typeof this.props.cb == 'function') {
          this.props.cb(response);
        }

        return Promise.resolve(response)
      }).catch(err => {
        Promise.reject(err);
      });

    } else {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
    }

    return false;
  }

  validateSubmitForm() {
    if (!this.state.image) {
      toastr.error('Lỗi!', 'Bạn vui lòng chọn banner');
      return false;
    }
    let pass = true;
    this.props.validators['formAddHomeBanner'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });

    if (!pass) {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
      return false;
    }

    return pass;
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    });
  }

  onUploadComplete(image, dataImage) {
    this.setState({
      image: image.name,
      dataImage
    });
  }

  onRemoveImage(image) {
    this.setState({image: null, dataImage: null})
  }

  render() {
    return (
      <div className="register-business-box home-banner-form">
        <form onSubmit={this.submitForm.bind(this)}>
          <SingleImageUploader
            fnUpload={HomeBanners.actions.upload.request}
            onUploadComplete={this.onUploadComplete.bind(this)}
            image={this.state.image}
            dataImage={this.state.dataImage}
            type="HOME_BANNER"
            onRemoveImage={this.onRemoveImage.bind(this)}
          />
          <div className="register-box-body">
            <Input type="text" placeholder="Link banner..."
              className='has-feedback fg-custom'
              iconClassName='fa-link'
              value={this.state.link}
              required={true}
              onChange={this.onChange.bind(this, 'link')}
              bindValidator={this} channel="formAddHomeBanner"
              errorMessage="Link banner không được để trống"
            />
            <Input type="proority" placeholder="Độ ưu tiên của banner..."
              className='has-feedback fg-custom'
              iconClassName='fa-sort-numeric-asc'
              value={this.state.priority}
              onChange={this.onChange.bind(this, 'priority')}
              required={true}
              bindValidator={this} channel="formAddHomeBanner"
              errorMessage="Bạn vui lòng cung cấp độ ưu tiên"
            />
            <div>
              <ShowIf condition={this.props.data}>
                <button type="submit" className="btn btn-primary btn-block btn-flat btn-submit text-btn">CẬP NHẬT BANNER</button>
              </ShowIf>
              <ShowIf condition={!this.props.data}>
                <button type="submit" className="btn btn-primary btn-block btn-flat btn-submit text-btn">THÊM BANNER</button>
              </ShowIf>
            </div>
          </div>
        </form>
    </div>
    );
  }
}

const bindStateToProps = state => {
  return {
    auth: state.auth
  }
}

export default withRouter(connect(bindStateToProps)(HomeBannerForm));



// WEBPACK FOOTER //
// ./components/home-banners/HomeBannerForm.jsx